import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: "Airport Transfers", href: "#services" },
      { name: "How It Works", href: "#how-it-works" },
    ],
    company: [
      { name: "Our Fleet", href: "#fleet" },
      { name: "Download App", href: "#app" },
    ],
    support: [
      { name: "FAQs", href: "/faq" },
      { name: "Contact Us", href: "/contact" },
      { name: "Terms of Service", href: "/terms" },
      { name: "Privacy Policy", href: "/privacy" },
    ],
  };

  const handleLinkClick = (href) => {
    if (href.startsWith("/")) {
      window.location.href = href;
    } else if (href.startsWith("#") && href !== "#") {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer id="contact" className="bg-sarathi-surface border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-10">
          {/* Brand Column */}
          <div className="col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_ev-mobility-2/artifacts/46iqyr35_logo-orange-white.svg"
              alt="Sarathi-X"
              className="h-8 mb-4"
            />
            <p className="text-sarathi-text-secondary text-sm mb-6 whitespace-nowrap">
              Premium electric vehicle mobility for airport transfers.
            </p>

            {/* Contact Info */}
            <div className="space-y-2.5">
              <a href="mailto:founder@sarathix.in" className="flex items-center gap-2 text-sarathi-text-secondary hover:text-sarathi-primary transition-colors text-sm">
                <Mail className="w-4 h-4 shrink-0" />
                founder@sarathix.in
              </a>
              <a href="tel:+919187057303" className="flex items-center gap-2 text-sarathi-text-secondary hover:text-sarathi-primary transition-colors text-sm">
                <Phone className="w-4 h-4 shrink-0" />
                +91 91870 57303
              </a>
              <div className="flex items-start gap-2 text-sarathi-text-secondary text-sm">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>Bengaluru, India</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <button
                    type="button"
                    onClick={() => handleLinkClick(link.href)}
                    className="text-sarathi-text-secondary hover:text-sarathi-primary transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <button
                    type="button"
                    onClick={() => handleLinkClick(link.href)}
                    className="text-sarathi-text-secondary hover:text-sarathi-primary transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">Support</h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.name}>
                  <button
                    type="button"
                    onClick={() => handleLinkClick(link.href)}
                    className="text-sarathi-text-secondary hover:text-sarathi-primary transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">Follow Us</h4>
            <div className="flex gap-3">
            {[
              { name: "Instagram", href: "https://www.instagram.com/withsarathix/", icon: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" },
            ].map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-sarathi-background/50 border border-white/10 rounded-xl flex items-center justify-center text-sarathi-text-muted hover:text-sarathi-primary hover:border-sarathi-primary/50 transition-all"
                aria-label={social.name}
                data-testid={`footer-social-${social.name.toLowerCase()}`}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d={social.icon} />
                </svg>
              </a>
            ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sarathi-text-muted text-sm">
            © {currentYear} Sarathi-X. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
